import Component, { newStore } from "../../../../Component";
import { MinimalGalleryState } from "../..";

import ViewBase, { reducers } from "./ViewBase";

export class SceneView extends Component<MinimalGalleryState> {
    constructor(props: __Component.Props) {
        super(props);
    }

    render() {
        const tsx = this.tsx;
        const config = this.props.base.applicationBaseResult.config;
        const store = newStore({
            reducers,
            initialState: {
                config,
                i18n: this.props.base.i18n,
                id: this.props.items.viewerItem.id,
                widgets: Object.keys(config)
                    .filter((key: string) => key.indexOf("Widget") !== -1)
                    .reduce((result: __Component.Pojo, key: string) => {
                        return { ...result, [key]: config[key] };
                    }, {}),
                viewModule: "esri/views/SceneView",
                webModule: "esri/WebScene",
                containerId: "map-container"
            },
            parentWidget: this.store.parentWidget
        });

        return (
            <ViewBase
                key="map-view"
                store={store}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/mainApp/MinimalGallery/Viewer/View/SceneView.tsx